import { ArrowLeft } from 'lucide-react'
import { useLanguage } from '@/hooks/useLanguage'
import { authT } from '../../locale'

interface AuthLinkSentNoticeProps {
  email: string
  onChangeEmail: () => void
}

export const AuthLinkSentNotice = ({ email, onChangeEmail }: AuthLinkSentNoticeProps) => {
  const { language } = useLanguage()
  const l = authT[language]
  // white by design: this notice renders on the fixed-dark Auth hero, not app surface
  return (
    <>
      <button
        type="button"
        onClick={onChangeEmail}
        className="flex items-center gap-2 text-sm text-white/50 hover:text-white/80 mb-6 transition-colors"
      >
        <ArrowLeft className="w-4 h-4" /> {l.sentBack}
      </button>

      <h1 className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-white mb-6 sm:mb-8">
        {l.sentTitle}
      </h1>

      <div className="rounded-2xl border border-border bg-surface p-6 mb-5">
        <p className="text-sm text-white/60 leading-relaxed">
          {l.sentBody1} <span className="font-semibold text-white">{email}</span>.
          <br />
          {l.sentBody2}
        </p>
      </div>

      <button
        type="button"
        onClick={onChangeEmail}
        className="text-sm font-semibold text-white hover:text-white/80 transition-colors"
      >
        {l.sentChangeEmail}
      </button>

      <p className="text-xs text-white/40 mt-6">
        {l.sentNoLink}
        <br />
        {l.sentSupportPrefix}{' '}
        <a
          href="https://t.me/open_academy_support_bot"
          target="_blank"
          rel="noopener noreferrer"
          className="text-brand hover:underline"
        >
          {l.sentSupportLink}
        </a>
      </p>
    </>
  )
}
